import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ConfidentialFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M9 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0m10 0a2 2 0 0 0-4 0l.01.204A2 2 0 0 0 19 18M14.925 2a3 3 0 0 1 2.854 1.866l.056.149.008.026 1.89 5.96H22a1 1 0 1 1 0 2H2a1 1 0 0 1 0-2h2.244l1.368-4.817A3 3 0 0 1 8.5 3H12c.149 0 .296-.033.43-.096l1.277-.612c.38-.182.796-.281 1.218-.292M21 18a4 4 0 0 1-7.995.205L13 18l-.005-.1A1 1 0 0 0 11 18l-.005.205a4 4 0 1 1-.794-2.602A3 3 0 0 1 12 15c.653 0 1.282.216 1.798.603A4 4 0 0 1 21 18" />
    </Icon>
  );
}

ConfidentialFillIcon.displayName = 'ConfidentialFillIcon';
